module.exports = __webpack_public_path__ + "static/media/cb.c02baaf8.png";